// @ts-nocheck

import classNames from 'classnames';
import React from 'react';

// NOTE: This component is deprecated, core component Checkbox should be used instead
export default class FormCheckbox extends React.Component {
  onChange(event) {
    this.props.onChange(event.target.checked);
  }

  render() {
    return (
      <div className={classNames('checkbox', this.props.className)} style={this.props.style}>
        <label>
          <input
            disabled={this.props.disabled}
            type="checkbox"
            value={this.props.value || ''}
            id={this.props.id}
            checked={this.props.value || ''}
            onChange={this.onChange.bind(this)}
          />
          {this.props.children || this.props.label}
        </label>
      </div>
    );
  }
}
